import { getGlobalHeadersAsObject } from "../global-headers";

export interface SendInviteQueueItem {
	id: number;
	priority: number;
	type: string;
	user_id: number | null;
	user_name: string | null;
	person_id: number;
	person_name: string | null;
	person_user_hash: string | null;
	person_vanity_name: string | null;
	last_sent_invite: string | null;
	assignment_id: number | null;
	assignment_name: string | null;
	created: string;
}

export interface SendInviteQueueResponse {
	count: number;
	next: string | null;
	previous: string | null;
	results: SendInviteQueueItem[];
}

export async function getPersonSendInviteQueue(
	personId: number
): Promise<SendInviteQueueResponse> {
	const response = await fetch(
		`/api/v2/send_invite_queue_v2/?person_id=${personId}&page_size=100`,
		{
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				...getGlobalHeadersAsObject(),
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to fetch SendInviteQueue: ${response.status}`);
	}

	return response.json();
}
